"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurHeartAndMission() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const principles = [{
    label: "PRINCIPLE 01 / ADVOCACY",
    title: "Empowering Voices",
    description: "We stand alongside neurodiverse families, ensuring their needs are heard, respected, and met with dignity in every community space.",
    terminus: "right"
  }, {
    label: "PRINCIPLE 02 / RESPITE",
    title: "Restorative Care",
    description: "We provide reliable, compassionate respite care that allows caregivers to recharge, knowing their loved ones are in safe, joyful hands.",
    terminus: "left"
  }, {
    label: "PRINCIPLE 03 / COMMUNITY",
    title: "Inclusive Connection",
    description: "Through bilingual resources and family-centered events, we build a vibrant neighborhood where every family feels they truly belong.",
    terminus: "right"
  }];
  return <section data-section-id="2135" id="our-heart-and-mission" className="bg-background text-foreground relative overflow-hidden border-t border-b border-primary/10">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 md:px-12 lg:px-18 py-24 md:py-32">
        {}
        <div ref={headRef} className={`mx-auto max-w-[880px] text-center transition-all duration-700 ease-out ${headVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          {}
          <div className="flex items-center justify-center gap-4 mb-10">
            <span className="hidden sm:block h-px w-6 bg-secondary" aria-hidden="true" />
            <span className="font-default uppercase font-bold text-secondary tracking-[0.18em]" style={{
            fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)"
          }}>
              § N° 02 — OUR MISSION
            </span>
          </div>

          {}
          <h2 className="font-default text-foreground" style={{
          fontSize: "clamp(2.25rem, 4.2vw, 4.25rem)",
          fontWeight: 700,
          lineHeight: 1.02,
          letterSpacing: "-0.02em"
        }}>
            We serve families{" "}
            <span className="font-default italic relative inline-block text-primary" style={{
            fontWeight: 400
          }}>
              together
              <span className={`absolute left-0 right-0 -bottom-2 h-px transition-transform duration-[480ms] ease-out origin-left ${headVisible ? "scale-x-100" : "scale-x-0"}`} style={{
              backgroundColor: "hsl(15 88% 54%)"
            }} aria-hidden="true">
                <span className="absolute right-0 -top-[2.5px] block h-[6px] w-[6px] rounded-lg bg-secondary" />
              </span>
            </span>
            , with heart, advocacy, and joy.
          </h2>
        </div>

        {}
        <div ref={gridRef} className="relative mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          {}
          <div className="hidden md:flex md:col-span-5 relative items-start justify-center">
            <span aria-hidden="true" className="font-default select-none leading-none text-primary/5" style={{
            fontSize: "clamp(12rem, 22vw, 22rem)",
            fontWeight: 700,
            letterSpacing: "-0.05em"
          }}>
              02
            </span>
          </div>

          {}
          <div className="md:col-span-7 flex flex-col">
            {principles.map((principle, i) => <div data-index={i} key={i} className={`group relative py-8 md:py-10 ${i !== 0 ? "border-t border-primary/10" : ""} transition-all duration-700 ease-out`} style={{
            transitionDelay: `${i * 80}ms`,
            transform: gridVisible ? "translateY(0)" : "translateY(24px)",
            opacity: gridVisible ? 1 : 0
          }}>
                {}
                {i !== 0 && <span aria-hidden="true" className={`absolute -top-[3px] block h-[6px] w-[6px] rounded-lg transition-transform duration-300 group-hover:scale-[1.4] ${principle.terminus === "right" ? "right-0" : "left-0"}`} style={{
              backgroundColor: "hsl(15 88% 54%)"
            }} />}

                {}
                <div className="font-default uppercase font-bold mb-4 text-secondary tracking-[0.18em]" style={{
              fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)"
            }}>
                  {principle.label}
                </div>

                {}
                <h3 className="font-default text-foreground transition-transform duration-300 ease-out group-hover:-translate-y-0.5" style={{
              fontSize: "clamp(1.5rem, 2.2vw, 2.125rem)",
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: "-0.012em"
            }}>
                  {principle.title}
                </h3>

                {}
                <p className="font-default mt-4 max-w-[52ch] text-muted-foreground" style={{
              fontSize: "0.9375rem",
              lineHeight: 1.65
            }}>
                  {principle.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}